<div class="chat-message_container">
  <div class="chat-message_content">
    <span *ngIf="message.type === 'ASSISTANT' && !isStreaming" class="copy-btn">
      <i class="material-icons" [cdkCopyToClipboard]="message.content" (cdkCopyToClipboardCopied)="onCopied()"
        >content_copy</i
      >
    </span>
    <hf-markdown [data]="getRenderedContent(message)" [isStreaming]="isStreaming" class="assistant-text"></hf-markdown>
  </div>
  <span class="date-stamp"
    >{{ message.createdDate | customDateTime }}
    <span *ngIf="showDelivered; else errorTemplate">
      <img src="/assets/icons/chatbot/done.svg" alt="delivered icon" />
    </span>
    <ng-template #errorTemplate>
      <img src="/assets/icons/chatbot/cancel.svg" alt="failed to deliver icon" />
      <p class="error-message">Failed to deliver message</p>
    </ng-template>
  </span>
</div>
